import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddedToCartMessage from "@insite/content-library/Components/ProductAddedToCartMessage";
import Accordion from "@insite/mobius/Accordion";
import { AccordionPresentationProps } from "@insite/mobius/Accordion/Accordion";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import AccordionSectionPanel from "@insite/mobius/AccordionSection/AccordionSectionPanel";
import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HorizontalRule } from "@ucs/Components/HorizontalRule";
import ChevronRight from "@ucs/Icons/ChevronRight";
import UCSColors from "@ucs/Utils/UCSColors";
import MyAccountProductSelector, { ProductSelectorStyles } from "@ucs/Widgets/MyAccountProductSelector";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const settingsCollection = getSettingsCollection(state);
    return {
        canOrderUpload: settingsCollection.orderSettings.canOrderUpload,
        showAddToCartConfirmationDialog: settingsCollection.productSettings.showAddToCartConfirmationDialog,
        orderUploadPageNavLink: getPageLinkByPageType(state, "OrderUploadPage"),
        quickOrderPageNavLink: getPageLinkByPageType(state, "QuickOrderPage"),
        allowQuickOrder: settingsCollection.orderSettings.allowQuickOrder,
    };
};

const mapDispatchToProps = {
    addToCart: makeHandlerChainAwaitable(addToCart),
};

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext;

export interface QuickOrderStyles {
    container?: GridContainerProps;
    titleGridItem?: GridItemProps;
    titleText?: TypographyPresentationProps;
    linksGridItem?: GridItemProps;
    orderUploadLink?: LinkPresentationProps;
    orderMultipleItemsLink?: LinkPresentationProps;
    productSelector?: ProductSelectorStyles;
    customContainer: any;
    containerName: any;
    viewAllButton: any;
    mobileLinksContainer: any;
    messagesAccordion?: AccordionPresentationProps;
}

export const quickOrderStyles: QuickOrderStyles = {
           containerName: {
               css: css`
                   flex: 1;
                   justify-content: flex-start;
               `,
           },
           mobileLinksContainer: {
               css: css`
                   display: block;
               `,
               item1: {
                   css: css`
                       display: block;
                   `,
               },
               item2: {
                   css: css`
                       display: block;
                       padding-bottom: 16px;
                   `,
               },
           },
           viewAllButton: {
               css: css`
                   flex: 1;
                   justify-content: flex-end;
                   align-items: flex-end;
                   span {
                       text-align: right;
                   }
               `,
           },
           messagesAccordion: {
               css: css`
                   width: 100%;
               `,
           },
           customContainer: {
               inlineContainer: {
                   css: css`
                       display: inline-flex;
                       flex-direction: row;
                       width: 100%;
                       gap: 16px;
                   `,
               },
               topHeadingContainer: {
                   css: css`
                       width: 100%;
                       margin-bottom: 8px !important;
                       ${({ theme }: { theme: BaseTheme }) =>
                           breakpointMediaQueries(theme, [
                               css`
                                   overflow: auto;
                               `,
                               css``,
                               css``,
                               css``,
                               css``,
                           ])}
                   `,
               },
               containerName: {
                   css: css`
                       display: flex;
                       flex: 1;
                       justify-content: flex-start;
                   `,
               },
               topContainerTile: {
                   css: css`
                       background: #ffffff;
                       padding-top: 10px;
                       padding-left: 20px;
                       padding-right: 20px;
                       padding-bottom: 2px;
                       box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
                       margin-bottom: 8px;
                   `,
               },
           },
           container: {
               gap: 15,
           },
           titleGridItem: { width: [12, 5, 5, 5, 5] },
           titleText: {
               variant: "h3",
               css: css`
                   margin-bottom: 0;
               `,
           },
           linksGridItem: {
               css: css`
                   ${({ theme }: { theme: BaseTheme }) =>
                       breakpointMediaQueries(theme, [
                           css`
                               padding-bottom: 20px;
                               padding-top: 0;
                           `,
                           css`
                               justify-content: flex-end;
                               // padding-top: 20px;
                           `,
                           css`
                               justify-content: flex-end;
                               // padding-top: 20px;
                           `,
                           css`
                               justify-content: flex-end;
                               // padding-top: 20px;
                           `,
                           css`
                               justify-content: flex-end;
                               // padding-top: 20px;
                           `,
                       ])}
               `,
           },
           orderMultipleItemsLink: {
               css: css`
                   margin-left: 20px;
               `,
           },
           productSelector: {
               searchItem: {
                   css: css`
                       /* width: 100%; */
                       flex: 1;
                       flex-grow: 1;
                       padding-top: 0px;
                   `,
               },
               qtyItem: {
                   css: css`
                       min-width: 160px;
                       padding-top: 0px;
                   `,
               },
               unitOfMeasureGridItem: { width: [9, 9, 2, 2, 2] },
               buttonGridItem: {
                   width: [12, 12, 3, 3, 2],
                   css: css`
                       padding-top: 0px;
                   `,
               },
               selectButton: {
                   css: css`
                       width: fit-content;
                       align-self: flex-end;
                       padding-top: 0px;
                       white-space: nowrap;
                   `,
               },
           },
       };

const styles = quickOrderStyles;

const QuickOrder: FC<Props> = ({
    canOrderUpload,
    showAddToCartConfirmationDialog,
    orderUploadPageNavLink,
    quickOrderPageNavLink,
    toaster,
    addToCart,
    allowQuickOrder,
}) => {
    const [errorMessage, setErrorMessage] = React.useState<React.ReactNode>("");

    if (!allowQuickOrder) {
        return null;
    }

    const addProductToCart = async (productInfo: ProductInfo) => {
        const cartline = (await addToCart({
            productId: productInfo.productId,
            qtyOrdered: productInfo.qtyOrdered,
            unitOfMeasure: productInfo.unitOfMeasure,
            onError: () => {
                setErrorMessage(siteMessage("Product_NotFound"));
            },
        })) as CartLineModel;

        if (showAddToCartConfirmationDialog) {
            toaster.addToast({
                body: <ProductAddedToCartMessage isQtyAdjusted={cartline.isQtyAdjusted} multipleProducts={false} />,
                messageType: "success",
            });
        }
    };

    return (
        <>
            <StyledWrapper {...styles.customContainer.topContainerTile}>
                <StyledWrapper {...styles.customContainer.topHeadingContainer}>
                    <Hidden below="md" {...styles.customContainer.inlineContainer}>
                        <Typography size={28} {...styles.containerName}>
                            {translate("Quick Order")}
                        </Typography>
                        {canOrderUpload && (
                            <Link
                                href={orderUploadPageNavLink ? orderUploadPageNavLink.url : undefined}
                                icon={{
                                    iconProps: {
                                        color: `${UCSColors.green00}`,
                                        size: 16,
                                        src: ChevronRight,
                                    },
                                }}
                            >
                                <Typography size={18} {...styles.viewAllButton}>
                                    {translate("Upload an Order")}
                                </Typography>
                            </Link>
                        )}
                        <Link
                            href={quickOrderPageNavLink ? quickOrderPageNavLink.url : undefined}
                            icon={{
                                iconProps: {
                                    color: `${UCSColors.green00}`,
                                    size: 16,
                                    src: ChevronRight,
                                },
                            }}
                        >
                            <Typography size={18} {...styles.viewAllButton}>
                                {translate("Order Multiple Items")}
                            </Typography>
                        </Link>
                    </Hidden>
                    <Hidden above="sm">
                        <Typography size={28} {...styles.containerName}>
                            {translate("Quick Order")}
                        </Typography>
                    </Hidden>
                </StyledWrapper>
                <Hidden below="md">
                    <HorizontalRule />
                </Hidden>
                <Hidden above="sm">
                    <StyledWrapper {...styles.mobileLinksContainer}>
                        <StyledWrapper {...styles.mobileLinksContainer.item1}>
                            {canOrderUpload && (
                                <Link
                                    href={orderUploadPageNavLink ? orderUploadPageNavLink.url : undefined}
                                    icon={{
                                        iconProps: {
                                            color: `${UCSColors.green00}`,
                                            size: 16,
                                            src: ChevronRight,
                                        },
                                    }}
                                >
                                    <Typography size={18} {...styles.viewAllButton}>
                                        {translate("Upload an Order")}
                                    </Typography>
                                </Link>
                            )}
                        </StyledWrapper>
                        <StyledWrapper {...styles.mobileLinksContainer.item2}>
                            <Link
                                href={quickOrderPageNavLink ? quickOrderPageNavLink.url : undefined}
                                icon={{
                                    iconProps: {
                                        color: `${UCSColors.green00}`,
                                        size: 16,
                                        src: ChevronRight,
                                    },
                                }}
                            >
                                <Typography size={18} {...styles.viewAllButton}>
                                    {translate("Order Multiple Items")}
                                </Typography>
                            </Link>
                        </StyledWrapper>
                    </StyledWrapper>
                </Hidden>

                <MyAccountProductSelector
                    selectButtonTitle={translate("Add to Cart")}
                    onSelectProduct={addProductToCart}
                    productIsConfigurableMessage={siteMessage("QuickOrder_CannotOrderConfigurable")}
                    productIsUnavailableMessage={siteMessage("QuickOrder_ProductIsUnavailable")}
                    customErrorMessage={errorMessage}
                    skipInventoryValidation={true}
                    extendedStyles={styles.productSelector}
                />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(QuickOrder)),
    definition: {
        group: "My Account",
    },
};

export default widgetModule;
